import React from 'react'
import './TokenBox.scss'
import crown from '../../../assets/crown.png'
import { Button } from '../../button/Button'

const TokenBox = ({header,competitionType1,competitionType2,onClick,onClick2}) => {
    return (
        <>
            <div className="token__box-header">
                <h1>{header}</h1>
            </div>

            <div className="token__box-competition">
                <div className="token__box-competition-type1">
                    <div className="competition-type1-header">
                        <h1>{competitionType1}</h1>
                        <div className="bottom-border-blue"></div>
                    </div>
                    <div className="competition-type1-prize">
                        <p>Our Seasional Event! Current Prize:</p>
                        <ul>
                            <li>
                                <div className="type1-prize-position"><h2>1</h2></div>
                                <img src={crown} alt="crown"/>
                                <div className="type1-prize-number">500</div>
                            </li>
                            <li>
                                <div className="type1-prize-position"><h2>2</h2></div>
                                <img src={crown} alt="crown"/>
                                <div className="type1-prize-number">150</div>
                            </li>
                            <li>
                                <div className="type1-prize-position"><h2>3</h2></div>
                                <img src={crown} alt="crown"/>
                                <div className="type1-prize-number">120</div>
                            </li>
                        </ul>
                    </div>
                    <div className="competition-type1-get-button">
                        <Button buttonColor="green" buttonSize="btn--wide" onClick={onClick}>Get</Button>
                    </div>
                </div>

                <div className="token__box-competition-type2">
                    <div className="competition-type2-header">
                        <h1>{competitionType2}</h1>
                        <div className="bottom-border-blue"></div>
                    </div>
                    <div className="competition-type2-prize">
                        <p>Our Seasional Event! Current Prize:</p>
                        <ul>
                            <li>
                                <img src={crown} alt="crown"/>
                                <div className="competition-type2-prize-number">113</div>
                            </li>
                        </ul>
                    </div>
                    <div className="competition-type2-get-button">
                        <Button buttonColor="green" buttonSize="btn--wide" onClick={onClick2}>Get</Button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TokenBox
